import { Translation } from 'cng-common/features/translations'
import { getFormattedFinance } from 'cng-common/helpers/numbers'

import { MDF_ACTIVITIES_TRANSLATION_KEYS } from '../../../../configs/translations'
import { MdfOverviewCard } from '../../../mdfOverviewCard'

import styles from './PaidOverviewCard.module.scss'

const KEYS = MDF_ACTIVITIES_TRANSLATION_KEYS.dashboard.overview.paid

interface IPaidOverviewCardProps {
  totalPaid: number
  percentPaid: number
  isUsd: boolean
  activeCurrency: string
}

export const PaidOverviewCard = ({
  totalPaid,
  percentPaid,
  isUsd,
  activeCurrency,
}: IPaidOverviewCardProps) => (
  <MdfOverviewCard
    title={KEYS.title}
    replaceParams={[{ key: '{currency}', value: activeCurrency }]}
    value={getFormattedFinance(totalPaid, {
      withCurrencySign: isUsd,
      maximumFractionDigits: 0,
    })}
    footer={
      <div className={styles.ofRequestedFooter}>
        <Translation text={KEYS.footerTitle} />
        <span>{String(percentPaid)}%</span>
      </div>
    }
  />
)

PaidOverviewCard.displayName = 'PaidOverviewCard'
